import React from "react";
import CardModal from "./CardModal";
import "./Portfolio.css";

import veve from "../Pictures/veve.JPG";
import f1 from "../Pictures/f1.jpeg";
import f2 from "../Pictures/f2.jpeg";

function Portfolio__Projects() {
  const project = [
    {
      image: veve,
      carousel: [veve],
      projectTitle: "Veve",
      projectInfo:
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Rerum sint odit beatae accusamus expedita, blanditiis laboriosam quis autem dolor culpa.",
      url: "www.veve.me",
    },
    {
      image: f2,
      carousel: [f1, f2],
      projectTitle: "Final Year Project",
      projectInfo:
        "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Rerum sint odit beatae accusamus expedita, blanditiis laboriosam quis autem dolor culpa.",
      url: ''
    },
  ];

  return (
    <div className="h-[100%] pt-[130px] pb-[130px]  md:pl-[70px] md:pr-[70px] pl-2 pr-2">
      <p className="text-center">
        <span className="p-2 about__me__title ">Portfolio</span>
      </p>
      <h1 className="text-center know__me__title mt-6 ">
        Some of my most recent projects
      </h1>
      <div className="row ">
        {project.map((data, index) => (
          <div className="col-md-6 d-flex justify-content-center">
            <CardModal 
            title={data.projectTitle}
            carousel={data.carousel}
            image={data.image}
            projectInfo={data.projectInfo}
            url={data.url}
            />
          </div>
        ))}

        {/* <div className="col-md-6 d-flex justify-content-center">
          <CardModal />
        </div> */}
      </div>
    </div>
  );
}

export default Portfolio__Projects;
